import { render, staticRenderFns } from "./teacherEdit.vue?vue&type=template&id=511d28fe"
import script from "./teacherEdit.vue?vue&type=script&lang=js"
export * from "./teacherEdit.vue?vue&type=script&lang=js"
import style0 from "./teacherEdit.vue?vue&type=style&index=0&id=511d28fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports